import ITranslation from "@/interfaces/ITranslation";

// cSpell:locale en-US
// cSpell:ignore Pedidos

const EnUS: ITranslation = {
  name: "Digital Waiter",
  description: "More flavor for your business",
  table: "Table",
  command: "Command",
  promotion: "Promotion",
  feedback: "Feedback",
  noneFound: "Nothing was found!",
  tryRemoveFilter: "Try removing a filter",
  priceFrom: "From",
  subtotal: "SubTotal",
  total: "Total",
  paidOut: "Paid",
  totalToPay: "Pay amount",
  serviceTax: "Service",
  optional: "Optional",
  additions: "Add",
  discount: "Discount",
  details: "Details",
  about: "About POP Pedidos",
  qrScanner: {
    scanner: "Scanner",
    search: "Search",
    installApp: "Install Digital Waiter",
    scanAnotherCode: "Scan another code",
    cannotAccessCamera: "Unable to access camera",
    enterQrCode: "Enter the table code below, it is under the QR Code!",
    enterCommandQrCode: "Enter the command code below, it is below the QR Code!",
    requiredCameraPermission: "Requires camera access",
    requireCameraPermission:
      "To scan the table's QR Code, allow the Digital Waiter to access the camera",
    manualQrCode: "Enter the code manually",
    readQrCodeToAccess: <>To access point the camera at the QR Code on the table</>,
    readCommandQrCodeToAccess: <>To access, point the camera at the command’s QR Code</>,
    cannotAccessTablet: "You do not own the Digital Waiter",
    needInstallApp: (
      <>
        You are using Digital Waiter in <b>Tablet at Table mode</b>,<br />
        to enjoy all the features it is <b>necessary</b> to install the our app!
      </>
    ),
  },
  modal: {
    success: "Success!",
    thanks: "Thanks!",
    okThanks: "Ok, Thanks!",
    close: "Close",
    save: "Save",
    back: "Back",
    confirm: "Confirm",
    notNow: "Not now",
    waiter: {
      extraCup: "Extra cup",
      cupWithIce: "Cup with ice",
      extraCutlery: "Extra cutlery",
      extraDish: "Extra dish",
      clearTable: "Clear table",
      anotherReasons: "Other reasons",
      callNow: "Call now",
      callWaiter: "Call waiter",
      rateLimit: "Wait a minute,\nyou're calling the waiter too fast!",
      called: (
        <>
          The waiter was called,
          <br />
          We will answer you in a few moments!
        </>
      ),
    },
    language: {
      title: "Change the language",
      confirm: "Confirm",
      portuguese: "Portuguese",
      brazil: "Brazil",
      english: "English",
      unitedStates: "United States",
      spanish: "Spanish",
      spain: "Spain",
    },
    account: {
      title: "My account",
      empty: "Nothing yet in your account!",
      splitBillQuestion: "Will you split the bill?",
      personsNumbers: "Nº of people",
      valuePerPerson: "Value per person",
      requestAccount: "Request account",
    },
    cart: {
      title: "Shopping cart",
      empty: "Empty cart!",
      sendOrder: "Make order",
      orderPaused: "Closed table",
      orderSended: (
        <>
          Your order has been successfully registered!
          <br />
          <br />
          To learn more about your orders, use the &quot;My Account&quot; option
          <br />
          <br />
          If in doubt, feel free to call the waiter. ✨
        </>
      ),
      belongsAnother: "This code belongs to another table",
    },
    feedback: {
      title: "Evaluation",
      thanks: "Success! Thank you for taking the time to give us a review!",
      didYouThink: "What did you think of our service?",
      opinionImportant: "Your opinion is very important, leave your review below!",
      yourName: "Your name",
      whatMainReason: "What are the main reasons for your ranking?",
      required:
        "You need to rate all options to submit your review, name and message fields are optional.",
      send: "Send Feedback",
    },
    poweredBy: {
      title: (
        <>
          The digital waiter that will <b>impress</b> your customers
        </>
      ),
      ordersOnTable: "Orders on the table",
      selfService: "Self service",
      innovationAndTechnology: "Innovation and technology",
      andMuchMore: (
        <>
          And <b>much</b> more!
        </>
      ),
    },
    product: {
      close: "Close product",
      next: "Next",
      update: "Update",
      add: "Add",
      anyObservation: "Any observation?",
      observationExample: "Example: Remove the onion and tomato, mayonnaise aside, etc.",
      quantity: "Quantity",
      quantityAndObservation: "Quantity and observation",
      unavailable: "Not available at this time",
      select: "Select",
      flavor: "Flavor",
      or: "or",
      to: "to",
      option: "option",
      options: "options",
      until: "up",
    },
    qrCodeConfirm: {
      title: "Table confirmation",
      titleCommand: "Command confirmation",
    },
    setupTable: {
      title: "Table number",
      message: "Enter your table number below:",
    },
    confirmOrder: {
      title: "Confirm order shipment?",
      message:
        "Once confirmed, your order will be shipped and cannot be changed or cancelled..",
    },
    table: {
      restrictArea: "Restricted area",
      title: "Table options",
      mode: "Operation mode",
      typePassword: "Type the password",
      tableNumber: "Table number",
      requestTableNumberInput: "Ask",
      reduceMotion: "Reduce animations and effects",
      autoBrightness: "Automatic brightness",
      clearTable: "clear table",
      clearAndCloseTable: "Clean and close table",
      signOut: "Exit the Digital Waiter",
      integrated: "This table is integrated!",
      signOutConfirm: "Click again to exit",
      buffet: "Buffet",
    },
    installApp: {
      appName: "Garçom Digital",
      configure: "Configure",
      configureHomeScreen: (
        <>
          You are in <b>Tablet at Table</b> mode, for a better experience
          <b>we recommend</b> setting Digital Waiter as an app
          <b>home screen default</b>!
        </>
      ),
    },
    deviceNotAuthorized: {
      title: "Not authorized!",
      message: "You have been disconnected.",
    },
    orderPaused: {
      title: "Receiving table!",
      message: "You cannot place orders while the table is reception.",
    },
  },
  error: {
    pageNotFound: "This page was not found",
    unexpectedError: "An unexpected error occurred",
    serverError: "An error occurred on the server",
    clientError: "Application Error: A client-side exception occurred",
  },
};

export default EnUS;
